import React from "react";
import { showToast } from "../../utils/toastUtils";
import CopyIcon from "../../assets/icons/CopyIcon";

export default function TextCopy({ text }: { text: string }) {
    return (
      <div
        className="group flex items-center gap-2 cursor-pointer hover:bg-[#F2F4F7] p-1 rounded transition transform active:scale-95 duration-150"
        onClick={() => {
          if (text) {
            navigator.clipboard.writeText(text);
            showToast("Copied Successfully", "success");
          }
        }}
        title="Click to copy"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && navigator.clipboard.writeText(text)}
      >
        <p className="text-sm text-[#344054]">{text}</p>
        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <CopyIcon />
        </span>
      </div>
    );
  }